import React from "react";
import shape6 from "../../images/shape-6.png";
import shape24 from "../../images/shape-24.png";
import shape23 from "../../images/shape-23.png";
import shape5 from "../../images/shape-5.png";
import shape8 from "../../images/shape-8.png";
import author from "../../images/author-03.jpg";
import course from "../../images/course.jpeg";
import course1 from "../../images/course.jpeg";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import axios from "axios";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

const QBank = ({pass, username}) => {
  let { id } = useParams();
  console.log(id);
  const navigate = useNavigate();
  const [Branchget, setBranchget] = useState([]);
  const [ids, setids] = useState([]);
  const [loggedOnce,setLoggedOnce]=useState(false);
    const [notLogged,setNotLogged]=useState(true);

  useEffect(() => {
    console.log(pass,username)
    if(sessionStorage.getItem("user_id")){
    axios.get("https://maps-medics-be.onrender.com/check_log/"+sessionStorage.getItem("user_id")+'/' +sessionStorage.getItem("token"))
    .then((res)=>{
      if(res.data.success===true){
        setNotLogged(false)
      }
    }).catch((err)=>{
      console.log(err)
    })
    }
    window.scrollTo(0, 0);
  }, []);
  const toQbank = `https://maps-medics.web.app/${username}/${pass}`;
  const loggedIn = "https://maps-medics.web.app/";
  const toLogIn = `/login`;
//   function Nav(s) {
//     setids(s);
//     // navigate("/courseDetails/"+s)
//     // navigate("/login");
//     sessionStorage.setItem("cource_id", s);
//     // sessionStorage.setItem('loggedIn', true); 
//     // Set the user's login status to true in local storage
//     if (sessionStorage.getItem('cource_id' , s) && sessionStorage.getItem('loggedIn')) {
//       // Check if the user is logged in and has a course ID set in local storage
//       navigate('/courseDetails/'+ sessionStorage.getItem('cource_id'));
//       // console.log('amjod')
//     } else {
//       navigate('/login'); // If the user is not logged in or does not have a course ID set, redirect to the login page
//       // console.log('dav')

//     }
//   }
  console.log(ids);
  async function getBranchget() {
    let { data } = await axios.post(
      `https://maps-medics-be.onrender.com/show_all_cources`, sessionStorage.getItem('user_id')?{student_id:  sessionStorage.getItem('user_id')}: {}
    );
    setBranchget(data.result);
    console.log(data.result);
  }


  // let currentIndex = 0;
  // console.log(lightContainer);
  useEffect(() => {
    console.log(username)
    console.log(pass)

    getBranchget();
  }, []);
  function showImage(x) {
    document
      .querySelector(".lightContainer")
      .classList.replace("d-none", "d-flex");
 
  }
  function closeSlide() {
    document
      .querySelector(".lightContainer")
      .classList.replace("d-flex", "d-none");
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
    {/* <Navbar/> */}
    <div className="section " ></div>

      <div class="section page-banner">

      <div style={{backgroundColor:'rgba(0,0,0,0.4)', width:'100%', height:'100%',display:'flex', justifyContent:'center', alignItems:'center'}}>

        <div class="container" style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
          <div class="page-banner-content">
           
            <h2 class="title" style={{color:'#fff'}}>
              Our <span>QBank.</span>
            </h2>
          </div>
        </div>

        </div>
      </div>
      <div class="section section-padding">
        <div class="container">
          <div class="courses-wrapper-02">
            <div class="row">
   
              <div class="col-lg-12 col-md-6 p-3">
            
                {Branchget.map((p, index) => (
                  <div class="single-courses row m-2" value={p.id} key={index}>
                    <div class="courses-images col-md-4">
                    <Link to='/QBankAdver' style={{textDecoration:'none', color:'#000'}}>  <a>
                        <img src={p.image} alt="Courses" />
                      </a></Link>
<span className="badger"></span>
                    
                    </div>
                    <div class="courses-content col-md-8">
                      <div className="row">
                        <div className="col-md-2" >
                        <div  className="courseCategories">
<div className="usmle">USMLE</div>
                      </div> 
                        </div>
                        <div className="col-md-10"><p style={{color:'#059de9', fontSize:'14px', fontFamily:'Poppins', fontWeight:'300'}}> {p.instructor}</p></div>
                      </div>
                                            

                      <div className="courseInstructor">
                        
                      </div>
                      <h3  style={{fontSize:'18px', fontWeight:'600', lineHeight:'24px', color:'#333', fontFamily:'Playfair Display', textAlign:'center'}}>{p.name}</h3>
                      <div className="row  p-2">
                        <div className="col">
                        <i class="fa-solid fa-clock" style={{color:'#ffc600'}}></i> 181 Questions
                        </div>
                        <div className="col">
                   <i class="fa-solid fa-chart-simple" style={{color:'#ffc600'}}></i> All Levels
                        </div>
                        <div className="col">
                           <i class="fa-solid fa-clone" style={{color:'#ffc600'}}></i> 10 System
                        </div>
                        {/* <div className="col">
                        <i class="fa-solid fa-puzzle-piece" style={{color:'#ffc600'}}></i> 20 Quizzes
                        </div> */}
                        {/* <div className="col">
                       <i class="fa-solid fa-user-graduate" style={{color:'#ffc600'}}></i> 65 Students
                        </div> */}
                      </div>
                      <div className="row p-2">
                        <p style={{marginBottom:'20px', color:'#666', fontSize:'16px', fontWeight:'300', lineHeight:'26px', fontFamily:'Poppins'}}>The Maps Medics USMLE Step 1 Preparatory Course is designed to help medical students succeed…</p>
                      </div>
     

 
                        <div className="row p-2">
                          <div className="col-md-3">
                          <h6 style={{ fontWeight: "bold" }}> <span className="khasm" style={{marginRight:'10px', color:"#666", fontSize:'14px', fontWeight:'300'}}>7500 EGP</span> {p.price}EGP</h6>

                          </div>
                          <div className="col-md-6"></div>
<div className="col-md-3" style={{float:'right'}}>
{/* <button
  class="btn btn-primary "
  //  onClick={() => showImage()}
  style={{
    backgroundColor: "#FFC600",
    border: "#FFC600",
  }}
//   onClick={() => Nav(p.id)}
>
    <a
    // to='/QBankAdver'
     href={`https://maps-medics.web.app/${username}/${pass}`}
      style={{color:'#fff', textDecoration:'none' }} >Start Learning 
<i class="fa-solid fa-book-open" style={{marginLeft:'5px'}}></i></a>

</button>   */}

{sessionStorage.getItem("logged_once")  ?    <a
                    onClick={()=>sessionStorage.setItem("logged_toqbank",true)}
                      href={toQbank}
                    
                      style={{color:'#fff', textDecoration:'none' }}
                    >
                      {" "}
                      <button class="btn  btn-primary"  style={{
    backgroundColor: "#FFC600",
    border: "#FFC600",
  }}>
                        {" "}
                        Start Learning  <i class="fa-solid fa-book-open"></i>{" "}
                      </button>
                    </a>:  <a
                      href={notLogged===true ? toLogIn:loggedIn }
                      onClick={() =>{
                        console.log(sessionStorage.getItem("user_id"))

                      }}
                      style={{color:'#fff', textDecoration:'none' }}
                    >
                      {" "}
                      <button class="btn  btn-primary"  style={{
    backgroundColor: "#FFC600",
    border: "#FFC600",
  }}> 
                        {" "}
                        Start Learning  <i class="fa-solid fa-book-open"></i>{" "}
                      </button>
                    </a>
                    }
</div>

                        </div>
                      
                     
                    </div>
                  </div>
                ))} 
              </div>
            </div>
          </div>
        </div>
      </div>
    
      {/* <Footer/> */}
    </>
  );
};

export default QBank;
